import { createAsyncThunk } from "@reduxjs/toolkit";
import { DBWorkspaceThunks, DBWorkspaceUserThunks } from "@common-reducers/DBServiceThunks";
import { CommonRootState } from "@common/types/common-root-state-type";

export const getWorkspaceDataThunk = createAsyncThunk<Promise<any>, { workspaceId: string }, { state: CommonRootState }>(
    "getWorkspaceDataThunk",
    async ({ workspaceId }, thunkApi) => {
        const { dispatch } = thunkApi;

        const promiseList: Promise<unknown>[] = [];
        promiseList.push(
            dispatch(
                DBWorkspaceThunks.find({
                    returnAlsoWorkspaceOwnerName: true,
                    _id: workspaceId,
                    deleted: { $ne: true },
                    $sort: {
                        name: 1,
                    },
                    $limit: -1,
                })
            ));

        promiseList.push(
            dispatch(
                DBWorkspaceUserThunks.find({
                    deleted: { $ne: true },
                    $sort: {
                        name: 1,
                    },
                    $limit: -1,
                })
            ));

        return Promise.all(promiseList);
    }
);